export const environment = {
  production: false,
  APP_ID: '6da461ef-df96-42bc-9ef7-62d7143cb958',
  PROMO_CODE: 'IHG',
  API_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/offers/api/ihgstatus',
  ASSETS_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/assets/img/',
  IMAGE_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com//ihgstatus/assets/',
};
